export const mainDataArray = ({ dropDowns, dataSource }) => [
  {
    id: "itemNumber",
    name: "itemNumber",
    type: "number",
    label: "Item",
    displayOnly: true,
  },
  {
    id: "higherLevelItem",
    name: "higherLevelItem",
    type: "number",
    label: "Higher Level Item",
  },
  {
    id: "itemCategoryId",
    name: "itemCategoryId ",
    type: "text",
    label: "Item Cat",
  },
];
export const additionalInputArray = ({ dropDowns, dataSource }) => [
  {
    id: "accountId",
    name: "accountId",
    label: "Account",
    tag: "select",
    options: dropDowns?.accounts || [],
  },
  {
    id: "postingCode",
    name: "postingCode",
    label: "Posting Code",
  },

];
export const referenceInputArray = ({ dropDowns, dataSource }) => [
  {
    id: "reference",
    name: "reference",
    label: "Reference",
  },
  {
    id: "DrCr",
    name: "DrCr",
    label: "DrCr",
    tag: "select",
    options: [
      { label: "Yes", value: "Y" },
      { label: "No", value: "N" },
    ],
  },
];
export const quantityArray = ({ dropDowns, dataSource }) => [
  {
    id: "amount",
    name: "amount",
    label: "Amount",
  },
  {
    id: "currencyId",
    name: "currencyId",
    label: "Currency",
    tag: "select",
    options: dropDowns?.currencies || [],
  },
];